import { Component, Input, OnChanges } from '@angular/core';
import { TableColumn } from 'src/app/shared/components/table/table-column.interface';
import { TableSearchRequest } from 'src/app/shared/components/table/table.component';
import { CaseService } from 'src/app/shared/services/case.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-company-group-cases',
  templateUrl: './company-group-cases.component.html',
  styleUrls: ['./company-group-cases.component.scss']
})
export class CompanyGroupCasesComponent implements OnChanges {

  @Input() companyGroupId!: number;

  caseList: any[] = [];
  resultsLength: number = 0;
  isLoadingResults: boolean = false;
  lastRequest?: TableSearchRequest;

  columns: TableColumn[] = [
    { key: 'caseReference',           label: 'Reference',         sortable: true, filterable: true },
    { key: 'instructedDate',          label: 'Instructed Date',   sortable: true, filterable: true, filterType: 'daterange' },
    { key: 'typeName',                label: 'Type',              sortable: true, filterable: true },
    { key: 'caseStatusName',          label: 'Status',            sortable: true, filterable: true },
    { key: 'caseSubStatusName',       label: 'Sub Status',        sortable: true, filterable: true },
    { key: 'caseTierSeverityType', label: 'Tier', sortable: true, filterable: true, filterType: 'select',
      filterOptions: [
        { label: 'None',   value: '{{int}}0' },
        { label: 'Green',  value: '{{int}}1' },
        { label: 'Amber',  value: '{{int}}2' },
        { label: 'Red',    value: '{{int}}3' },
      ]
    },
    { key: 'caseCompletionPercentage',label: 'Completion %',      sortable: true },
    { key: 'addedByName',             label: 'Added By',          sortable: true, filterable: true },
    { key: 'allocatedToParalegalName',label: 'Paralegal',         sortable: true, filterable: true },
    { key: 'allocatedToAdminName',    label: 'Admin',             sortable: true, filterable: true },
    { key: 'partyOneLastName',        label: 'Client Surname',   sortable: true, filterable: true },
    { key: 'partyOneAddressLine1',    label: 'Address',           sortable: true, filterable: true },
    { key: 'partyOnePostcode',        label: 'Postcode',          sortable: true, filterable: true },
  ];

  constructor(private caseService: CaseService,
     private router: Router
  ) {}

  ngOnChanges(): void {
    if (this.companyGroupId && this.lastRequest) {
      this.loadCases(this.lastRequest);
    }
  }

  onSearch(request: TableSearchRequest) {
    this.lastRequest = request;
    if (!this.companyGroupId) return;
    this.loadCases(request);
  }

  private loadCases(request: TableSearchRequest) {
    this.isLoadingResults = true;
    this.caseService.companyGroupCases(this.companyGroupId, request).subscribe({
      next: data => {
        this.caseList = data.items;
        this.resultsLength = data.recordCount;
        this.isLoadingResults = false;
      },
      error: () => this.isLoadingResults = false
    });
  }

  gotoCase(c: any) {
    this.router.navigate(['/case', c.id]);
  }
}